const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE)

export const apiLoyaltyPoints = {
	fetchLoyaltyPoints: async (uuid: string): Promise<IPointLoyaltyPointModel> => {
		const { data } = await apiCommon<IPointLoyaltyPoint[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(undefined, { client_uuid: uuid }),
		})

		return PointLoyaltyPoint(data[0])
	},
	createClientLoyaltyPoints: async (payload: IPointLoyaltyPointPayload, clientId: number) => {
		const { data } = await apiCommon(`${groupPrefix}/loyalty/${clientId}/adjustments`, {
			method: 'POST',
			body: payload,
		})

		return data
	},
}
